
import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator'
import { API_URLS } from '@/utils/helpers'
import GenericTable from '@/components/GenericTable.vue'
import { BvTableFieldArrayWithStickColumn } from '@/types/base'
import { IMinimalOrganization } from '@/types/projects'
import CheckboxField from '@/components/processing_steps/commons/fields/CheckboxField.vue'

@Component({
  components: {
    GenericTable,
    CheckboxField
  }
})
export default class ShowcaseTemplateOrgaSelect extends Vue {
  @Ref() selectableTable!: GenericTable
  @Prop() initialSharedWith!: string[]
  apiUrl = API_URLS.ORGANIZATIONS.LIST
  addProjectMode = false
  selectedOrgas: string[] = []
  fields: BvTableFieldArrayWithStickColumn = [
    { key: 'title', label: this.$gettext('Organization title'), sortable: true },
    { key: 'fixed_action_col', label: this.$gettext('Actions') }
  ]

  mounted (): void {
    this.selectedOrgas = [...this.initialSharedWith]
  }

  @Watch('initialSharedWith', { immediate: true })
  updateSelectedOrgas (): void {
    this.selectedOrgas = [...this.initialSharedWith]
  }

  get apiUrlExtraParams () {
    if (this.addProjectMode) {
      return {}
    } else {
      return { slugs: this.selectedOrgas.join(',') }
    }
  }

  changeApiUrl () {
    this.addProjectMode = !this.addProjectMode
    this.$nextTick(() => {
      this.selectableTable.loadItems()
    })
  }

  isSelected (orga: IMinimalOrganization) {
    return this.selectedOrgas.includes(orga.slug)
  }

  toggleOrgaSelection (data: IMinimalOrganization) {
    if (this.selectedOrgas.includes(data.slug)) {
      this.selectedOrgas = this.selectedOrgas.filter(orga => orga !== data.slug)
    } else {
      this.selectedOrgas.push(data.slug)
    }
    this.$emit('update:initialSharedWith', this.selectedOrgas)
  }

  orderSelectedOrgasFirst (orgas: IMinimalOrganization[]) {
    return orgas.sort((a, b) => {
      const aSelected = this.selectedOrgas.includes(a.slug)
      const bSelected = this.selectedOrgas.includes(b.slug)
      if (aSelected && !bSelected) return -1
      if (!aSelected && bSelected) return 1
      return 0
    })
  }
}
